import { iEye, iThumbsUp, iZap } from '@hover/icons';
import { IProsRestorationInfo } from '../interfaces/IProsRestorationInfo';

export const PROS_RENDERINGS: Array<IProsRestorationInfo> = [
  {
    id: 0,
    icon: iEye,
    header: 'Visualize the full project',
    body: 'Incorporate multiple trades into a single HOVER Design, creating a complete visual representation of the work to be done.',
  },
  {
    id: 1,
    icon: iZap,
    header: 'Inspire your customers',
    body: 'Seamlessly integrate design services into your sales process and turn sources of inspiration into reality.',
  },
  {
    id: 2,
    icon: iThumbsUp,
    header: 'Build trust and confidence',
    body: 'Gain consensus on the project scope with customers so that they know what to expect from the start.',
  },
];
